<template>
  <side-nav-section
    :active="$route.name.includes('traqing')"
    :user="user"
    :section="consts.SIDENAV_TRAQING_SECTION"
  >
    <template v-if="!user.isExpert">
      <side-nav-item :item="consts.SIDENAV_TRAQING_STATUS_ROUTE" />
      <side-nav-item :item="consts.SIDENAV_TRAQING_REPORT_ROUTE" />
    </template>
    <template v-else>
      <side-nav-item :item="consts.SIDENAV_TRAQING_COACH_ROUTE" />
    </template>
  </side-nav-section>
</template>

<script>
import {
  SIDENAV_TRAQING_SECTION,
  SIDENAV_TRAQING_REPORT_ROUTE,
  SIDENAV_TRAQING_STATUS_ROUTE,
  SIDENAV_TRAQING_COACH_ROUTE,
} from "Consts/sideNav/traqingSection";
import SideNavSection from "Public/components/SideNav/SideNavSections/SideNavSection";
import SideNavItem from "Public/components/SideNav/SideNavItem";
export default {
  name: "TraqingSection",
  components: { SideNavItem, SideNavSection },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      consts: {
        SIDENAV_TRAQING_SECTION,
        SIDENAV_TRAQING_REPORT_ROUTE,
        SIDENAV_TRAQING_STATUS_ROUTE,
        SIDENAV_TRAQING_COACH_ROUTE,
      },
    };
  },
};
</script>

<style scoped></style>
